<div>
  <nav class="navbar">
    <div style="width: 200px">
      <b matTooltip="{{ account.accountName }}">
        {{ firstName(account.accountName) }}
      </b>
    </div>

    <div>
      <img src="assets/logoNavbar.png" class="imgLogo" />
    </div>

    <div style="display: flex; gap: 10px">
      <div
        class="btn-user"
        style="
          display: flex;
          align-items: center;
          gap: 5px;
          min-width: 120px;
          justify-content: space-between;
        "
      >
        <div style="min-width: 75px; position: relative">
          <div *ngIf="loading" style="position: absolute; z-index: 2; left: 40%">
            <mat-spinner [diameter]="25"></mat-spinner>
          </div>
          <span
            [ngStyle]="{
              filter: !walletAmmount.isShowing ? 'blur(6px)' : 'none',
              cursor: walletAmmount.isShowing ? 'pointer' : 'default'
            }"
            style="font-weight: bold; padding-left: 2px; text-decoration: underline"
            (click)="walletAmmount.isShowing ? goToWallet() : ''"
          >
            R$ {{ walletAmmount.ammount }}
          </span>
        </div>
        <fa-icon
          [title]="walletAmmount.isShowing ? 'Ocultar saldo' : 'Ver saldo'"
          [icon]="walletAmmount.isShowing ? 'eye' : 'eye-slash'"
          style="cursor: pointer"
          (click)="walletDetails()"
        ></fa-icon>
      </div>
      <div>
        <button
          mat-menu-item
          [matMenuTriggerFor]="sub_menu"
          class="btn-user"
          matTooltip="Menu de usuário"
        >
          <fa-icon icon="user"></fa-icon>&nbsp;
          {{ firstName(account.userName) }}
        </button>
        <mat-menu #sub_menu="matMenu">
          <button mat-menu-item *ngIf="!userRegistration" (click)="goToProfile()">
            Dados cadastrais
          </button>
          <button mat-menu-item *ngIf="!userRegistration" (click)="resetPass()">
            Alterar senha
          </button>
          <button mat-menu-item *ngIf="!userRegistration" (click)="goToWallet()">Carteira</button>
          <button mat-menu-item (click)="logout()">Sair</button>
        </mat-menu>
      </div>
    </div>
  </nav>

  <section class="page-content">
    <mat-card class="menu-aside" *ngIf="!userRegistration">
      <div *ngFor="let item of menu">
        <ng-container *ngIf="item.submenu.length === 0">
          <button mat-menu-item (click)="onClick(item)">
            <div>
              <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>&nbsp;
              <span class="hideOnMobile">{{ item.label }}</span>
            </div>
          </button>
        </ng-container>

        <ng-container *ngIf="item.submenu.length > 0">
          <button mat-menu-item [matMenuTriggerFor]="sub_menu">
            <div>
              <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>&nbsp;
              <span class="hideOnMobile">{{ item.label }}</span
              >&nbsp;
              <fa-icon icon="angle-right" align="right"></fa-icon>
            </div>
          </button>
          <mat-menu #sub_menu="matMenu">
            <div *ngFor="let subItem of item.submenu">
              <button mat-menu-item (click)="onClick(subItem)">
                {{ subItem.label }}
              </button>
            </div>
          </mat-menu>
        </ng-container>
      </div>
    </mat-card>

    <div class="content">
      <ng-content></ng-content>
    </div>
  </section>
</div>
